import React from "react";

import { Login } from "../features/auth";

const LoginPage = () => {
  return <Login />;
};

export default LoginPage;
